import { EntryNameDialog } from "@/components/file-tree/EntryNameDialog";

interface NewFolderDialogProps {
	open: boolean;
	onConfirm: (name: string) => Promise<void>;
	onCancel: () => void;
}

export function NewFolderDialog({ open, onConfirm, onCancel }: NewFolderDialogProps) {
	return (
		<EntryNameDialog
			open={open}
			title="新規フォルダ"
			label="フォルダ名"
			confirmLabel="作成"
			testIdPrefix="new-folder-dialog"
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
}
